import React from "react";

import MainContainer from "../../components/MainContainer";
import MainHeader from "../../components/MainHeader";
import MainHeaderButtonsWrapper from "../../components/MainHeaderButtonsWrapper";
import Title from "../../components/Title";
import { i18n } from "../../translate/i18n";

const AdminNew = () => {
  return (
    <MainContainer>
      <MainHeader>
        <Title>{i18n.t("mainDrawer.listItems.adminNew")}</Title>
        <MainHeaderButtonsWrapper />
      </MainHeader>
      <div style={{ padding: 16 }}>
        {i18n.t("mainDrawer.listItems.adminNew")} content will be here
      </div>
    </MainContainer>
  );
};

export default AdminNew;
